export const environment = {
  name: 'dev',
  production: true,
  apiClientId: '4b3pn1r1k2vb15t9b8er4kvkr0',
  userPoolId: 'eu-west-1_hk6OmkfwU',
  graphqlEndpoint: 'https://pwyz46laejhx3e4i67pvitlvjm.appsync-api.eu-west-1.amazonaws.com/graphql',
  eventsEndpoint: 'https://gnfchs43erehjakafdrdcy7wq4.appsync-api.eu-west-1.amazonaws.com/event',
  graphqlApiKey: 'da2-7zfnzfe5vzadddyzrgsjcxay7e',
}
